import React, { useState, useEffect, useRef } from 'react'
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
// setDataLayout removed - using fixed horizontal layout
import ImageWithBasePath from "../imageWithBasePath";
import {
  setMobileSidebar,
} from "../../data/redux/sidebarSlice";
import { all_routes } from "../../../feature-module/router/all_routes";
import { HorizontalSidebarData } from '../../data/json/horizontalSidebar'
import TermsAndConditions from '../termsAndConditions';
import { getAPIHeaders, getRememberMe, getTenant, removeAccessToken, removeAuthToken, 
	removeRefreshAuthToken, removeTenantID, storeUserProfile, removeUserProfile, getUserProfile } from '../../../common/Utils';
import useFetch from '../../../hooks/useFetch';
import { useAuth } from '../../../hooks/authContext';
import { Profile , Notification} from '../../data/interface';
import { API } from '../../../common/Constants';
import moment from 'moment';
import { Empty } from 'antd';
import HeaderLogo from "../headerLogo";

const DEFAULT_PROFILE_PIC = "assets/img/profiles/avatar-27.jpg";

const Header = () => {
  const routes = all_routes;
  const { callFetch } = useFetch();
  const dispatch = useDispatch();
  const Location = useLocation();
  const [showTermsAndConditions, setShowTermsAndConditions] = useState(false);
  const mobileSidebar = useSelector(
    (state: any) => state.sidebarSlice.mobileSidebar
  );
  const { setAuthUser, setIsLoggedIn } = useAuth();
  const [userProfile, setUserProfile] = useState<Profile>();
  const [imagePreview, setImagePreview] = useState(DEFAULT_PROFILE_PIC);
  const [notifications, setNotifications] = useState<Notification[]>([]);
  const notificationInterval = useRef<any | null>(null);
  const [menuItems, setMenuItems] = useState<any[]>(HorizontalSidebarData);

  useEffect(() => {
	if(userProfile?.profileSettings?.institution_website){
		let menu = HorizontalSidebarData
		let mainMenu = menu.find((item) => item.title === 'Main')?.menu;
		if(mainMenu && mainMenu.findIndex((item) => item.menuValue === 'Home') === -1){
			mainMenu = [
				{
					menuValue: 'Home',
					hasSubRoute: false,
					showSubRoute: false,
					icon: 'home',
					base: 'home',
					route: userProfile?.profileSettings?.institution_website,
				},
				...mainMenu
			]
			menu[0].menu = mainMenu;
		}
		setMenuItems(menu)
	}
    
  }, [userProfile]);
  
  useEffect(() => {
    fetchProfile();
    fetchProfilePic();
    fetchNotification();
    checkTermsAndConditions();

    notificationInterval.current = setInterval(() => {
      fetchNotification();
    }, 30000);

    return () => {
      if (notificationInterval.current) {
        clearInterval(notificationInterval.current);
      }
    };
  }, []);

  const checkTermsAndConditions = () => {
	callFetch(API.TERMS_AND_CONDITIONS_STATUS, "GET", getAPIHeaders(), null, null)
	  .then((response) => {
		setShowTermsAndConditions(!response?.hasConsented);
	  }).catch((error) => {
		console.error("Error fetching terms and conditions status:", error);
	  });
  };

	const fetchProfile = () => {
	callFetch(`${API.COMM_USER_PROFILE}`, "GET", getAPIHeaders(), null, null)
		.then((res) => {
		setUserProfile(res);
		storeUserProfile(res);
		})
		.catch((err) => {});
	};

	const fetchNotification = () => {
	callFetch(`${API.NOTIFICATION_UNREAD}`, "GET", getAPIHeaders(), null, null)
		.then((res) => {
		if (res && res.length) {
			const sortedNotifications = [...res].sort((a, b) => 
			new Date(b.sentAt || 0).getTime() - new Date(a.sentAt || 0).getTime());
			setNotifications(sortedNotifications);
		} else {
			setNotifications([]);
		}
		})
		.catch((err) => {});
	};

	const fetchProfilePic = () => {
	callFetch(`${API.PROFILE_IMAGE}`, "GET", getAPIHeaders(), null, null)
		.then((res) => {
		if (res && res.fileUrl) {
			setImagePreview(res.fileUrl);
		} else {
			setImagePreview(DEFAULT_PROFILE_PIC);
		}
		})
		.catch(() => {
		setImagePreview(DEFAULT_PROFILE_PIC);
		});
	};

	const ackNotification = (ids?: number[]) => {
	callFetch(`${API.NOTIFICATION_ACK}`, "POST", getAPIHeaders(), null, ids)
		.then(() => {
		fetchNotification();
		})
		.catch((err) => {
		});
	};

  const toggleMobileSidebar = () => {
    dispatch(setMobileSidebar(!mobileSidebar));
  };
  
  const onClickLogOut = () => {
	const tenantId = getTenant();
    !getRememberMe() && removeTenantID();
    removeAuthToken();
    removeRefreshAuthToken();
	removeAccessToken();
    setIsLoggedIn(false);
    setAuthUser(null);
	removeUserProfile();
    // Use window.location.href for a hard redirect to ensure logout works
    window.location.href = tenantId ? `/login?tenant=${encodeURIComponent(tenantId)}` : "/login";
  };


  const [isFullscreen, setIsFullscreen] = useState(false);
  const toggleFullscreen = () => {
    if (!isFullscreen) {
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen().catch((err) => {
        });
        setIsFullscreen(true);
      }
    } else {
      if (document.exitFullscreen) {
        if (document.fullscreenElement) {
          document.exitFullscreen().catch((err) => {
          });
        }
        setIsFullscreen(false);
      }
    }
  };

  return (
    <>
	<TermsAndConditions 
        show={showTermsAndConditions} 
        onAccept={() => {setShowTermsAndConditions(false)}} 
        onDecline={onClickLogOut}/>
      {/* Header */}
      <div className="header">
			<div className="main-header">

				<div className="header-left">
					<Link to="/index" className="d-flex justify-content-center mt-1">
						<HeaderLogo url={userProfile?.profileSettings?.institution_logo}
						 name={userProfile?.profileSettings?.institution_name}
						 />
					</Link>
				</div>

				<Link id="mobile_btn" onClick={toggleMobileSidebar} className="mobile_btn" to="#sidebar">
					<span className="bar-icon">
						<span></span>
						<span></span>
						<span></span>
					</span>
				</Link>

				<div className="header-user p-0">
					<div className="nav user-menu nav-list justify-space-between">

						<div className="sidebar sidebar-horizontal" id="horizontal-single">
							<div className="sidebar-menu">
								<div className="main-menu">
									<ul className="nav-menu">
										<li className="menu-title">
											<span>Main</span>
										</li>
										{menuItems?.map((mainMenu, index) => (
											<React.Fragment key={`main-${index}`}>
												{mainMenu?.menu?.map((data: any, i: number) => (
												<li key={`menu-${i}`}>
													<Link 
														to={data.route || "#"} 
														className={data.route === Location.pathname ? "active" : ""}
													>
														<i className={`ti ti-${data.icon}`}></i>
														<span>{data.menuValue}</span>
													</Link>
												</li>
												))}
											</React.Fragment>
											))}
									</ul>
								</div>
							</div>
						</div>

						<div className="d-flex align-items-center">
							<div className="me-1">
								<Link to="#" onClick={toggleFullscreen} className="btn btn-menubar btnFullscreen">
									<i className="ti ti-maximize"></i>
								</Link>
							</div>
			
							<div className="me-1 notification_item">
								<Link to="#" className="btn btn-menubar position-relative me-1" id="notification_popup"
									data-bs-toggle="dropdown">
									<i className="ti ti-bell"></i>
									{notifications?.length ? (
									<span className="notification-status-dot"></span>
									) : (
									<></>
									)}
								</Link>
								<div className="dropdown-menu dropdown-menu-end notification-dropdown p-4">
									<div className="d-flex align-items-center justify-content-between border-bottom p-0 pb-3 mb-3">
									<h4 className="notification-title">
										Notifications ({notifications?.length})
									</h4>
									<div className="d-flex align-items-center">
										<button
										className="btn text-primary fs-15 me-3 lh-1"
										onClick={(event: any) => {
											event.stopPropagation();
											event.preventDefault();
											let ids = notifications
											?.map(
												(notification: Notification) => notification?.id
											)
											.filter((id): id is number => id !== undefined);
											if (ids?.length) {
											ackNotification(ids);
											}
										}}
										>
										Mark all as read
										</button>
									</div>
									</div>
									<div className="noti-content d-flex" style={{ maxHeight: "300px", overflowY: "auto", width: "100%" }}>
									<div className="d-flex flex-column w-100">
										{notifications?.length ? (
										notifications?.map(
											(notification: Notification, index: number) => {
											return (
												<div className="border-bottom mb-3 pb-3">
												<div className="pb-0">
													<div className="d-flex">
													<div className="flex-grow-1">
														<p className="mb-2">
														<span className="text-dark fw-semibold">
															{notification?.title}{" "}
														</span>
														<span className="text-gray">
															{" "}
															{notification?.message}
														</span>
														</p>
														<span className="text-dark">
														{formatNotificationTime(
															notification?.sentAt
														)}
														</span>
														<div className="d-flex justify-content-start align-items-center mt-2">
														<button
															className="btn btn-primary btn-sm me-2"
															onClick={(event: any) => {
															event.stopPropagation();
															event.preventDefault();
															if (notification?.id) {
																ackNotification([
																notification?.id,
																]);
															}
															}}
														>
															Mark as Read
														</button>
														</div>
													</div>
													</div>
												</div>
												</div>
											);
											}
										)
										) : (
										<div className="d-flex justify-content-center">
											<Empty />
										</div>
										)}
									</div>
									</div>
								</div>
							</div>
							<div className="dropdown profile-dropdown">
								<Link to="#" className="dropdown-toggle d-flex align-items-center" data-bs-toggle="dropdown">
									<span className="avatar avatar-sm online">
									<ImageWithBasePath
										src={imagePreview || DEFAULT_PROFILE_PIC}
										alt="Img"
										className="img-fluid rounded-circle"
									/>
									</span>
								</Link>
								<div className="dropdown-menu shadow-none">
									<div className="card mb-0">
										<div className="card-header">
											<div className="d-flex align-items-center">
												<span className="avatar avatar-lg me-2 avatar-rounded">
													<ImageWithBasePath
														src={imagePreview || DEFAULT_PROFILE_PIC}
														alt="img"
													/>
												</span>
												<div>
													<h5 className="mb-0">
														{userProfile?.firstName} {userProfile?.lastName}
													</h5>
													<p className="fs-12 fw-medium mb-0">
														{userProfile?.username}
													</p>
												</div>
											</div>
										</div>
										<div className="card-body">
											<Link className="dropdown-item d-inline-flex align-items-center p-0 py-2" to={routes.profile}>
												<i className="ti ti-user-circle me-1"></i>My Profile
											</Link>
										</div>
										<div className="card-footer">
											<Link className="dropdown-item d-inline-flex align-items-center p-0 py-2" to="" 
												onClick={onClickLogOut}>
												<i className="ti ti-login me-2"></i>Logout
											</Link>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className="dropdown mobile-user-menu">
					<Link to="#" className="nav-link dropdown-toggle" 
						data-bs-toggle="dropdown" 
						aria-expanded="false"
					>
						<i className="fa fa-ellipsis-v"></i>
					</Link>
					<div className="dropdown-menu dropdown-menu-end">
						<Link className="dropdown-item" to={routes.profile}>
							<i className="ti ti-user me-2"></i>My Profile
						</Link>
                        <Link
                          className="dropdown-item"
                          to=""
                          onClick={onClickLogOut}
                        >
                          <i className="ti ti-login me-2"></i>Logout
                        </Link>
					</div>
				</div>

			</div>

	  </div>
      {/* /Header */}
    </>
  );
};

export default Header;

function formatNotificationTime(timestamp?: string) {
	const now = moment();
	const time = moment(timestamp);
	const diffInHours = now.diff(time, "hours");
  
	if (diffInHours < 24) {
	  return time.fromNow();
	} else {
	  return time.format("MMMM Do YYYY, h:mm A");
	}
}

